<ng-container *ngIf="currentOrg?.user === false">
  <a
    *ngIf="currentOrg?.isFreePlan === false"
    [modeLegacyRouterLink]="['/', currentOrg?.username, 'spaces']"
    modeLegacyRouterLinkActive="selected"
    class="heading-link"
    [class.analyst-studio]="isAnalystStudio$ | async"
    data-intercom="collections-nav-all-collections-link"
    [target]="target"
  >
    <span class="mode-nav-header link-title">Collections</span>
    <capra-icon icon="icon-chevron" class="link-icon" [class.analyst-studio]="isAnalystStudio$ | async"></capra-icon>
  </a>
  <div *ngIf="currentOrg?.isFreePlan" class="heading-link">
    <span class="mode-nav-header link-title">Collections</span>
  </div>
</ng-container>
<ul *ngIf="isCollectionsLoading" class="loading" [class.analyst-studio]="isAnalystStudio$ | async">
  <li></li>
  <ng-container *ngIf="currentOrg?.isFreePlan === false">
    <li></li>
    <li></li>
  </ng-container>
</ul>
<ul [class.analyst-studio]="isAnalystStudio$ | async">
  <li
    *ngFor="
      let collection of filteredCollections
        | slice: 0:(showAllCollections ? filteredCollections.length : collectionLimit)
    "
  >
    <a
      [modeLegacyRouterLink]="['/', currentOrg?.username, 'spaces', collection.token]"
      modeLegacyRouterLinkActive="selected"
      [target]="target"
    >
      <capra-icon [icon]="getCollectionIcon(collection)"></capra-icon>
      <div class="title">
        <span *ngIf="collection.viewed === false" class="new-prefix">NEW</span>
        {{ collection.name }}
      </div>
    </a>
  </li>
</ul>
<a
  *ngIf="collectionLimit < filteredCollections.length"
  href="#"
  class="filter-show-link"
  [class.analyst-studio]="isAnalystStudio$ | async"
  (click)="showAllCollections = !showAllCollections"
>
  {{ moreText() }}
</a>
